<template>
	<v-card class="pa-4 elevation-1">
		
			<form ref="form">
				<v-row>	
					<v-col>
						<v-text-field v-model="name" label="Name"></v-text-field>
					</v-col>
					<v-col>
						<v-text-field v-model="email" label="Email"></v-text-field>
					</v-col>
				</v-row>
				<v-row>	
					<v-col>
						<v-textarea v-model="message" label="Message"></v-textarea>

					</v-col>
				</v-row>
			</form>
			<p class="text-right">
				<v-btn color="primary" dark rounded @click="sendMessage">Absenden</v-btn>
			</p>
	</v-card>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "ContactForm", 
		props: {
			
		},
		data: () => {
			return {
				message: null, 
				email: null, 
				name: null
			}
		},
		// components: {

		// },
		computed: {
			...Vuex.mapState({
				user: state => state.user
			})
		},
		methods: {
			sendMessage(){
				const self = this;
				var msg = {
					content: self.message, 
					from: self.user ? self.user.id : 'visitor',
					email: self.email, 
					name: self.name
				}
				self.$store.dispatch("mail/contactFormEmail", msg ).then(( response ) => {
					console.log( response );
					self.$refs.form.reset();
				} )

			}
		},
		watch: {
			user: {
				immediate: true,
				handler(){				
					if( this.user ){
						// this.email = this.user.email;
						// this.name = this.user.display_name
					}
				}
			}
		}
		// created(){
			
		// }

	}
</script>